import * as C from '../constants';

export default {
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_LIST_PENDING](state) {
    state.list = {
      ...state.list,
      loading: true,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_CHANNEL_LIST_SUCCESS](state, payload) {
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: false,
    };
    state.channels = {
      ...state.channels,
      items: payload,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_LIST_FAILURE](state) {
    state.list = {
      ...state.list,
      error: true,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_LIST_NO_CONTENT](state) {
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_JOB_LIST_PENDING](state) {
    state.jobs = {
      ...state.jobs,
      items: [],
    };
    state.list = {
      ...state.list,
      error: false,
      loading: true,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_JOB_LIST_SUCCESS](state, payload) {
    state.jobs = {
      ...state.jobs,
      items: payload,
    };
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_JOB_LIST_FAILURE](state, payload) {
    state.list = {
      ...state.list,
      errorMessage: payload,
      error: true,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_JOB_LIST_NO_CONTENT](state) {
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_IMPORT_LIST_PENDING](state) {
    state.list = {
      ...state.list,
      items: [],
      error: false,
      loading: true,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_IMPORT_LIST_SUCCESS](state, payload) {
    state.list = {
      ...state.list,
      items: payload,
      error: false,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_IMPORT_LIST_FAILURE](state, payload) {
    state.list = {
      ...state.list,
      errorMessage: payload,
      error: true,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_IMPORT_LIST_NO_CONTENT](state) {
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_PUSH_LIST_PENDING](state) {
    state.list = {
      ...state.list,
      items: [],
      error: false,
      loading: true,
      noContent: false,
    };
    state.pushPrices = {
      ...state.pushPrices,
      items: [],
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_PUSH_LIST_SUCCESS](state, payload) {
    state.list = {
      ...state.list,
      items: payload,
      error: false,
      loading: false,
      noContent: false,
    };
    state.pushPrices = {
      ...state.pushPrices,
      items: payload,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_PUSH_LIST_FAILURE](state, payload) {
    state.list = {
      ...state.list,
      errorMessage: payload,
      error: true,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_PUSH_LIST_NO_CONTENT](state) {
    state.list = {
      ...state.list,
      error: false,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_PRODUCTS_LIST_PENDING](state) {
    state.channels = {
      ...state.channels,
      channelProducts: [],
    };
    state.filter = {
      ...state.filter,
      error: false,
      loading: true,
      noContent: false,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_CHANNEL_PRODUCTS_LIST_SUCCESS](state, payload) {
    state.channelProducts = {
      ...state.channelProducts,
      items: payload,
    };
    state.filter = {
      ...state.filter,
      error: false,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_PRODUCTS_LIST_FAILURE](state) {
    state.filter = {
      ...state.filter,
      error: true,
      loading: false,
      noContent: false,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CHANNEL_PRODUCTS_LIST_NO_CONTENT](state) {
    state.filter = {
      ...state.filter,
      error: false,
      loading: false,
      noContent: true,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_SET_CHANNEL](state, payload) {
    state.filter = {
      ...state.filter,
      channel: payload,
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_SET_TYPE](state, payload) {
    state.filter = {
      ...state.filter,
      type: payload,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CLEAR_CHANNEL](state) {
    state.filter = {
      ...state.filter,
      channel: {},
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CLEAR_TYPE](state) {
    state.filter = {
      ...state.filter,
      type: {},
    };
  },
  /**
   * @param state
   */
  [C.PRICES_LIST_RESET](state) {
    state.list = {
      ...state.list,
      noContent: false,
      errorMessage: '',
      error: false,
      items: [],
    };
    state.pushPrices = {
      ...state.pushPrices,
      items: [],
    };
  },
  /**
   * @param state
   */
  [C.PRICES_CLEAR_STATE](state) {
    state.filter = {
      ...state.filter,
      channel: {},
      type: {},
    };
  },
  /**
   * @param state
   * @param payload
   */
  [C.PRICES_SET_PAGINATION_INDEX](state, payload) {
    state.filter = {
      ...state.filter,
      paginationIndex: payload,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_UPDATE_PAGINATION_INDEX](state) {
    state.filter = {
      ...state.filter,
      paginationIndex: state.filter.paginationIndex += 1,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_RESET_PAGINATION_INDEX](state) {
    state.filter = {
      ...state.filter,
      paginationIndex: 1,
    };
  },
  /**
   * @param state
   */
  [C.PRICES_LOAD_NEW_PAGE](state) {
    state.filter = {
      ...state.filter,
      loadNewPage: state.filter.loadNewPage += 1,
    };
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/prices/mutations.js